import React from 'react';
import './skeleton-base.css';

const SkeletonBlogCard = () => (
    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-4 skeleton-card">
        <div className="card explore-box card-animate" style={{ minHeight: "250px" }}>
            <div className="card-body" style={{ padding: "20px", display: "flex", flexDirection: "column" }}>
                <div style={{ flex: 1 }}>
                    {/* Blog title skeleton - larger than video titles */}
                    <div className="skeleton-element skeleton-delay-1" style={{
                        height: "20px",
                        width: "85%",
                        marginBottom: "12px"
                    }}>
                        <div className="skeleton-shimmer"></div>
                    </div>
                    
                    {/* Blog description skeleton - multiple lines */}
                    <div className="skeleton-element skeleton-delay-2" style={{
                        height: "14px",
                        width: "100%",
                        marginBottom: "8px"
                    }}>
                        <div className="skeleton-shimmer"></div>
                    </div>
                    <div className="skeleton-element skeleton-delay-3" style={{
                        height: "14px",
                        width: "80%",
                        marginBottom: "8px"
                    }}>
                        <div className="skeleton-shimmer"></div>
                    </div>
                    <div className="skeleton-element skeleton-delay-4" style={{
                        height: "14px",
                        width: "60%",
                        marginBottom: "16px"
                    }}>
                        <div className="skeleton-shimmer"></div>
                    </div>
                </div>
                
                {/* Bottom section with category and bookmark */}
                <div className="d-flex justify-content-between align-items-center">
                    <div className="skeleton-element skeleton-delay-5" style={{
                        height: "12px",
                        width: "35%"
                    }}>
                        <div className="skeleton-shimmer"></div>
                    </div>
                    <div className="skeleton-element skeleton-icon skeleton-delay-2">
                        <div className="skeleton-shimmer"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default SkeletonBlogCard;